import { apiGet } from 'lib/apiClient'

/* === базовые === */

export async function summaryAll() {
  const { data, error } = await apiGet('/dashboard/summary/');
  if (error) throw new Error(error);
  return data || {
    total_items: 0,
    total_incoming_qty: 0,
    total_outgoing_qty: 0,
    total_returns_qty: 0,
    current_balance_qty: 0
  };
}

export async function lowStock() {
  const { data, error } = await apiGet('/dashboard/low-stock/');
  if (error) throw new Error(error);
  return data || [];
}

export async function recentActs(limit = 10) {
  const { data, error } = await apiGet('/dashboard/recent-acts/', { limit });
  if (error) throw new Error(error);
  return data || [];
}

/* === доп. показатели === */

// количество пользователей приложения
export async function countAppUsers() {
  const { data, error } = await apiGet('/dashboard/count-app-users/');
  if (error) throw new Error(error);
  return data?.count || 0;
}

// активных назначений (status=active)
export async function countActiveAssignments() {
  const { data, error } = await apiGet('/dashboard/count-active-assignments/');
  if (error) throw new Error(error);
  return data?.count || 0;
}

// вход/расход/возвраты за сегодня
export async function actsTodayByType() {
  const { data, error } = await apiGet('/dashboard/acts-today-by-type/');
  if (error) throw new Error(error);
  return data || { in: 0, out: 0, return: 0 };
}

// движения за 7 дней (по дням и типам)
export async function movesLast7Days() {
  const { data, error } = await apiGet('/dashboard/moves-last-7-days/');
  if (error) throw new Error(error);
  return data || [];
}

// разрез остатков по категориям
export async function stockByCategory() {
  const { data, error } = await apiGet('/dashboard/stock-by-category/');
  if (error) throw new Error(error);
  return data || [];
}

// последние активные назначения (для ленты)
export async function recentAssignments(limit = 10) {
  // NOTE: Bu endpoint hozircha mavjud emas
  // Hozircha bo'sh array qaytaradi
  return [];
}

export async function totalInventoryValue() {
  const { data, error } = await apiGet('/dashboard/total-inventory-value/');
  if (error) throw new Error(error);
  // Backend returns { total_value: ... }
  return data?.total_value || 0;
}
